export default "__VITE_ASSET__8e4c856d__"